import { useEffect } from "react";
import { BrowserRouter as Router, Routes, Route, Outlet, useLocation } from "react-router-dom";
import { AppShell } from "./components/AppShell";

import Dashboard from "./pages/Dashboard";
import StockIn from "./pages/StockIn";
import StockOut from "./pages/StockOut";
import History from "./pages/History";
import BomRule from "./pages/BomRule";
import Products from "./pages/Products";
import AddProduct from "./pages/AddProduct";
import StockOpname from "./pages/StockOpname";
import { DialogProvider } from "./components/DialogProvider";
import { AuthProvider } from "./auth/AuthProvider";
import { RequireAdmin, RequireAuth, RequireRole } from "./auth/RequireAuth";
import Login from "./pages/Login";
import Activity from "./pages/Activity";
import AdminSettings from "./pages/AdminSettings";
import AdminApproval from "./pages/AdminApproval";
import { AppSettingsProvider } from "./settings/AppSettingsProvider";
import Events from "./pages/Events";
import EventDetail from "./pages/EventDetail";
import Kasir from "./pages/Kasir";
import RekapKasir from "./pages/RekapKasir";
import RekapEvent from "./pages/RekapEvent";

// Accountant Pages
import AccountantDashboard from "./pages/accountant/AccountantDashboard";
import AccountantReconciliations from "./pages/accountant/AccountantReconciliations";
import AccountantNotes from "./pages/accountant/AccountantNotes";
import AccountantStock from "./pages/accountant/AccountantStock";

function TitleManager() {
  const { pathname } = useLocation();

  useEffect(() => {
    const app = "BRRADS Inventory";
    const map = {
      "/": "Dashboard",
      "/stock-in": "Stock Masuk",
      "/stock-out": "Stock Keluar",
      "/history": "History",
      "/stock-opname": "Stock Opname",
      "/products": "Products",
      "/products/new": "Tambah Produk",
      "/bom-rule": "Bundle",
      "/activity": "Aktivitas",
      "/admin": "Admin Settings",
      "/admin/approval": "Approval Request",
      "/login": "Login",
      "/events": "POS Event",
      "/accountant/dashboard": "Dashboard Audit",
      "/accountant/reconciliations": "Rekonsiliasi Kas",
      "/accountant/notes": "Daftar Temuan",
      "/accountant/stock": "Pantau Stok",
    };

    const page = map[pathname] || "";
    document.title = page ? `${page} — ${app}` : app;
  }, [pathname]);

  return null;
}

function AppLayout() {
  return (
    <AppShell>
      <Outlet />
    </AppShell>
  );
}

function App() {
  return (
    <DialogProvider>
      <AuthProvider>
        <AppSettingsProvider>
          <Router>
            <TitleManager />
            <Routes>
              <Route path="/login" element={<Login />} />

              <Route
                element={
                  <RequireAuth>
                    <AppLayout />
                  </RequireAuth>
                }
              >
                <Route element={<RequireRole allowedRoles={['admin', 'staff']}><Outlet /></RequireRole>}>
                  <Route path="/" element={<Dashboard />} />
                  <Route path="/stock-in" element={<StockIn />} />
                  <Route path="/stock-out" element={<StockOut />} />
                  <Route path="/history" element={<History />} />
                  <Route path="/stock-opname" element={<StockOpname />} />
                </Route>

                {/* POS Event */}
                <Route element={<RequireRole allowedRoles={['admin', 'staff', 'kasir']}><Outlet /></RequireRole>}>
                  <Route path="/events" element={<Events />} />
                  <Route path="/events/:id" element={<EventDetail />} />
                  <Route path="/kasir/:sessionId" element={<Kasir />} />
                  <Route path="/rekap/event/:eventId" element={<RekapEvent />} />
                  <Route path="/rekap/:sessionId" element={<RekapKasir />} />
                </Route>

                {/* Accountant Mode */}
                <Route element={<RequireRole allowedRoles={['admin', 'accountant']}><Outlet /></RequireRole>}>
                  <Route path="/accountant/dashboard" element={<AccountantDashboard />} />
                  <Route path="/accountant/reconciliations" element={<AccountantReconciliations />} />
                  <Route path="/accountant/notes" element={<AccountantNotes />} />
                  <Route path="/accountant/stock" element={<AccountantStock />} />
                </Route>

                <Route
                  path="/admin"
                  element={
                    <RequireAdmin>
                      <AdminSettings />
                    </RequireAdmin>
                  }
                />
                <Route
                  path="/admin/approval"
                  element={
                    <RequireAdmin>
                      <AdminApproval />
                    </RequireAdmin>
                  }
                />
                <Route
                  path="/products"
                  element={
                    <RequireAdmin>
                      <Products />
                    </RequireAdmin>
                  }
                />
                <Route
                  path="/products/new"
                  element={
                    <RequireAdmin>
                      <AddProduct />
                    </RequireAdmin>
                  }
                />
                <Route
                  path="/bom-rule"
                  element={
                    <RequireAdmin>
                      <BomRule />
                    </RequireAdmin>
                  }
                />
                <Route
                  path="/activity"
                  element={
                    <RequireAdmin>
                      <Activity />
                    </RequireAdmin>
                  }
                />
              </Route>
            </Routes>
          </Router>
        </AppSettingsProvider>
      </AuthProvider>
    </DialogProvider>
  );
}

export default App;